module.exports = __webpack_public_path__ + "static/media/green-lose.2546a832.png";